import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const RejectDevisModal = ({
	setShowRejectDevisModal,
	showRejectDevisModal,
	setMessageValue,
	postMessage,
	cas,
	updateDevisState
}) => {

	const handleRejection = (e) => {
		e.preventDefault();
		const waitUpdateState = async () => {
			// Update du statut du devis en BDD
			await updateDevisState(2);
		};
		waitUpdateState().then(() => {
			// Envoie l'explication du refus
			postMessage();
			// Reset l'input message
			setMessageValue("");
			// Ferme la modal
			setShowRejectDevisModal(false);
		});
	};

	return (
		<>
			<div className="content">
				<p className="title">Confirmation</p>
				<div className="container-modal">
					<p className="subtitle">
						Êtes-vous sûr de vouloir refuser ce devis ? <br/>
						Donnez nous les raisons de votre refus : <br/>
						<textarea className="rejectInput" type="text" onChange={(e) => setMessageValue(e.target.value, cas.id)}/>
					</p>
				</div>
				<form action="" onSubmit={handleRejection}>
					<div className="containerButton">
						<button className="buttonModalPap orange">Oui, je confirme</button>
						<button className="buttonModalPap white">Annuler</button>
					</div>
				</form>
			</div>
			<div className="modalBackground" onClick={() => showRejectDevisModal ? setShowRejectDevisModal(false) : null}  ></div>
		</>
	);
};

RejectDevisModal.propTypes = {
	setShowRejectDevisModal: PropTypes.func,
	showRejectDevisModal: PropTypes.bool,
	setMessageValue: PropTypes.func,
	postMessage: PropTypes.func,
	updateDevisState: PropTypes.func,
	showPap: PropTypes.bool,
	cas: PropTypes.object,
};

export default RejectDevisModal;
